/** @jsxImportSource @emotion/react */

import { memo } from "react";
import { useIntl, FormattedMessage } from "react-intl";

import { Typography } from "@material-ui/core";

import { Group, Label } from "..";
import useHyperlinksByLocale from "../../hooks/useHyperlinksByLocale";

import { info } from "./styles";

interface Props {
  arranged: boolean;
  className?: string;
}

const SupportGroup = ({ arranged, className }: Props): JSX.Element => {
  const intl = useIntl();
  const { CONTACT_URL } = useHyperlinksByLocale();

  return (
    <Group
      className={className}
      title={intl.formatMessage({
        id: "support-group.operation-support",
      })}
    >
      <Label text={intl.formatMessage({ id: "support-group.support-status" })} />
      <Typography css={info(1)} variant="body1">
        <FormattedMessage id={arranged ? "support-group.arranged" : "support-group.being-arranged"} />
      </Typography>
      <Typography css={info(3)} variant="body1">
        <span>
          {intl.formatMessage(
            {
              id: "support-group.contact-info",
            },
            {
              a: (chunk) => (
                <a href={CONTACT_URL} target="_blank" rel="noreferrer noopener">
                  {chunk}
                </a>
              ),
            }
          )}
        </span>
      </Typography>
    </Group>
  );
};

export default memo(SupportGroup);
